// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#other-office-connection-edit[data-v-e9e46cc0]{max-width:660px;margin-left:auto;margin-right:auto}#other-office-connection-edit .cancel-btn[data-v-e9e46cc0],#other-office-connection-edit .update-btn[data-v-e9e46cc0]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
